import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Badge, BadgeService } from '@services/badge.service';

@Component({
  selector: 'app-badge-edit',
  templateUrl: './badge-edit.component.html',
     styleUrls: ['./badge-edit.css']
})
export class BadgeEditComponent implements OnInit {
  @Input() isEditMode = false;
  @Input() badge: Badge = { id: 0, name: '', image: '', description: '', order: 0, active: true };

  saving = false;

  constructor(
    public activeModal: NgbActiveModal,
    private badgeService: BadgeService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {}

  save(): void {
    if (!this.badge.name?.trim()) {
      this.toastr.warning('Rozet adı zorunludur', 'Uyarı');
      return;
    }

    this.saving = true;

    const request = this.isEditMode
      ? this.badgeService.update(this.badge.id, this.badge)
      : this.badgeService.add(this.badge);

    request.subscribe(
      () => {
        this.toastr.success(
          this.isEditMode ? 'Rozet başarıyla güncellendi' : 'Rozet başarıyla oluşturuldu',
          'Başarılı'
        );
        this.saving = false;
        this.activeModal.close(true);
      },
      () => {
        this.toastr.error('İşlem sırasında hata oluştu', 'Hata');
        this.saving = false;
      }
    );
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }
}
